import { render, staticRenderFns } from "./employeeDialog.vue?vue&type=template&id=246be4e6&scoped=true&"
import script from "./employeeDialog.vue?vue&type=script&lang=js&"
export * from "./employeeDialog.vue?vue&type=script&lang=js&"
import style0 from "./employeeDialog.vue?vue&type=style&index=0&id=246be4e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246be4e6",
  null
  
)

export default component.exports